<div class="first-line">
  Dubletten erkannt bei "{{ inhaberDto?.bezeichnung }}
  {{ inhaberDto?.betriebsnummer ? ', ' + inhaberDto?.betriebsnummer : '' }}"
</div>

<div class="second-line">Wir haben beim Upload einige Dubletten erkannt, dein Handeln ist nun erforderlich.</div>

<div class="third-line">
  <jf-button [variant]="'outline'" (doClick)="openDublettenDialog()">Dubletten ansehen</jf-button>
</div>
